import { ModelBase } from '../../core/model/model-base';
import { LocalDate } from '../../core/model/local-date';

export class RentalObjectRentalBlock extends ModelBase {
  private _fromDate: LocalDate;
  private _toDate: LocalDate;

  constructor(data?: Partial<RentalObjectRentalBlock>) {
    super();
    Object.assign(this, data);
  }

  get fromDate(): LocalDate {
    return this._fromDate;
  }
  set fromDate(value: LocalDate) {
    this._fromDate = LocalDate.fromDate(value);
  }

  get toDate(): LocalDate {
    return this._toDate;
  }
  set toDate(value: LocalDate) {
    this._toDate = LocalDate.fromDate(value);
  }

  project: string = null;
  reason: string = null;

  toJSON() {
    const json = Object.assign({}, this);
    json.fromDate = this.fromDate;
    json.toDate = this.toDate;
    return json;
  }
}
